<template>
  <div>
    <div class="select-wrap">
      <div>
        <el-date-picker
          v-model="time"
          :picker-options="pickerOptions"
          @change="onChangeTime"
          :clearable="false"
          unlink-panels
          type="daterange"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="small">
        </el-date-picker>
      </div>

      <div>
          <el-button type="primary" @click="getData" size="small">查询</el-button>
      </div>
    </div>
    <div class="card-wrap">
      <div>
        <div class="card-title">已发货金额</div>
        <div class="card-content"><span class="card-content-money">￥</span>{{totalData.send_amount?totalData.send_amount:0}}</div>
        <div class="card-footer">单数：<span class="card-footer-money">{{totalData.send_count?totalData.send_count:0}}</span></div>
      </div>
      <div>
        <div class="card-title">退款金额</div>
        <div class="card-content"><span class="card-content-money">￥</span>{{totalData.refund_amount?totalData.refund_amount:0}}</div>
        <div class="card-footer">单数：<span class="card-footer-money">{{totalData.refund_count?totalData.refund_count:0}}</span></div>
      </div>
      <div>
        <div class="card-title">实结金额</div>
        <div class="card-content"><span class="card-content-money">￥</span>{{totalData.already_amount?totalData.already_amount:0}}</div>
        <div class="card-footer">单数：<span class="card-footer-money">{{totalData.already_count?totalData.already_count:0}}</span></div>
      </div>
      <div>
        <div class="card-title">未结金额</div>
        <div class="card-content"><span class="card-content-money">￥</span>{{totalData.not_amount?totalData.not_amount:0}}</div>
        <div class="card-footer">单数：<span class="card-footer-money">{{totalData.not_count?totalData.not_count:0}}</span></div>
      </div>
    </div>
    <div class="summary-report-wrap">
      <el-table :data="tableData"
      style="width: 100%"
      :loading="loading"
      @expand-change="expandChange"
      :row-key="row=> row.created_time">
        <el-table-column type="expand" width="30">
          <!-- <template slot="header" slot-scope="scope">
            展开行
          </template> -->
          <template slot-scope="scope">
            <div  v-loading="scope.row.loading">
              <el-table :data="scope.row.list" style="width:100%">
                <el-table-column
                type="index"
                label=""
                width="100"
                >
                  <template slot="header" slot-scope="pos">
                    <el-select
                    :value="scope.row.search"
                    @change="((val)=>searchDetailHandler(val,scope.row.created_time))"
                    placeholder="请选择"
                    size="mini">
                      <el-option
                        v-for="item in plainOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </template>
                  <!-- <template slot-scope="scope">
                    {{scope.name}}
                  </template> -->
                </el-table-column>
                <!-- <el-table-column type="index" label="序号">
                </el-table-column> -->
                <el-table-column prop="sku_name" label="商品名称">
                </el-table-column>
                <el-table-column prop="order_amount" label="供货金额" width="100">
                </el-table-column>
                <el-table-column prop="total_amount" label="结算金额" width="100">
                </el-table-column>
                <el-table-column prop="payment_bill_status_text" label="状态" width="120">

                  <template slot-scope="scope">
                    {{filterType(scope.row.order_type,scope.row.order_status_text,scope.row.payment_bill_status_text).status}}
                  </template>
                </el-table-column>
                <el-table-column prop="payment_bill_status" label="原因">
                  <template slot-scope="scope">
                    {{filterType(scope.row.order_type,scope.row.order_status_text,scope.row.payment_bill_status_text).reason}}
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="100">
                  <template slot-scope="scope">
                    <el-button @click="detailHandler(scope.row.id)" type="text">
                      查看
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                style="text-align:center;"
                @current-change="((val)=>handleCurrentChangeChild(val,scope))"
                :current-page="scope.row.currentPage"
                :page-size="10"
                layout="total, prev, pager, next, jumper"
                :total="scope.row.totalCount"
              >
              </el-pagination>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="created_time" label="日期">
          <template slot-scope="scope">
            {{scope.row.created_time}}
          </template>
        </el-table-column>
        <el-table-column prop="send_amount" label="已发货金额"></el-table-column>
        <el-table-column prop="refund_amount" label="退款金额"></el-table-column>
        <el-table-column prop="already_amount" label="实结金额"></el-table-column>
        <el-table-column prop="not_amount" label="未结金额"></el-table-column>
        <!-- <el-table-column prop="amount" label="交易金额">
          <template slot-scope="scope">
            {{scope.row.amount}}
          </template>
        </!-->
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 50, 100, 200]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      >
      </el-pagination>
    </div>
    <div>
      <el-dialog
        title="订单详情"
        :visible.sync="centerDialogVisible"
        append-to-body
        width="70%"
        center>
        <div>
          <div class="dialog-content">
            <div>类型：{{dialogData.order_type_text}}</div>
            <div>供货成交价：{{dialogData.order_price}}</div>
          </div>
          <div class="dialog-content">
            <div>主订单号：{{dialogData.main_number}}</div>
            <div>数量：{{dialogData.order_quantity | fixedNumber}}</div>
          </div>
          <div class="dialog-content">
            <div>子订单号：{{dialogData.order_number}}</div>
            <div>供货金额：{{dialogData.order_amount}}</div>
          </div>
          <div class="dialog-content">
            <div>售后单号：{{dialogData.as_number}}</div>
            <div>OMS单据状态：{{dialogData.order_status_text}}</div>
          </div>
          <div class="dialog-content">
            <div>推送时间：{{dialogData.push_time}}</div>
            <div>核算确认时间：{{dialogData.payment_bill_created_on}}</div>
          </div>
          <div class="dialog-content">
            <div>供货时间/售后确认时间：{{dialogData.supply_time}}</div>
            <div>预计结算时间：{{dialogData.expect_settle_date}}</div>
          </div>
          <div class="dialog-content">
            <div>主单状态：{{dialogData.ap_order_status_text}}</div>
            <div>结算状态：{{dialogData.payment_bill_status_text}}</div>
          </div>
          <div class="dialog-content">
            <div>单位：{{dialogData.unit}}</div>
            <div>结算金额：{{dialogData.total_amount}}</div>
          </div>
          <div class="dialog-content">
            <div>锐锢编码：{{dialogData.sku_code}}</div>
            <div>付款/扣款时间：{{dialogData.paid_on}}</div>
          </div>
          <div class="dialog-content">
            <div>商品名称：{{dialogData.sku_name}}</div>
            <div></div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <!-- <el-button @click="centerDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button> -->
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
// cosnt disabledDate = current => current && current > moment().endOf('day') || current < moment().subtract(3, 'months')
import moment from 'moment'
import {getReportCollectTotal, getReportCollectDetail, getReportCollectList, getReportCollectInfo} from '@/models/reportModel'
const isType = type => target => `[object ${type}]` === Object.prototype.toString.call(target)
const isNumber = isType('Number')
const plainOptions = [
  {
    label: '全部',
    value: ''
  },
  {
    label: '发货',
    value: 1
  },
  {
    label: '退款',
    value: 2
  },
  {
    label: '实结',
    value: 3
  },
  {
    label: '未结',
    value: 4
  }
]

export default {
  props: ['type'],
  data () {
    return {
      loading: false,
      expandLoading: false,
      centerDialogVisible: false,
      plainOptions: plainOptions,
      search: '',
      checkedList: [],
      tableData: [],
      time: [moment().subtract(7, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
      dialogData: {},
      totalData: {},
      page: 1,
      pagesize: 10,
      totalCount: 0,
      pickerOptions: {
        disabledDate (time) {
          if (moment(time).format('YYYY-MM-DD') < '2019-06-01') {
            return true
          } else {
            return false
          }
        }
      }
    }
  },
  filters: {
    fixedNumber (val) {
      let value = Number(val)
      return isNaN(isNumber(value)) ? '' : parseFloat(value)
    }
  },
  methods: {
    moment,
    filterType (type, orderStatus, status) {
      let str = {
        status: '',
        reason: ''
      }
      if (type === '2') {
        str.status = '售后退货'
        str.reason = '售后退货'
      }
      if (type === '1' && status === '已付款') {
        str.status = '已付款'
        str.reason = '已付款'
      }
      if (type === '1' && status !== '已付款') {
        str.status = '未结账'
        if (orderStatus === '已完成') {
          str.reason = '未到结账周期'
        }
        if (orderStatus && orderStatus !== '已完成') {
          str.reason = '商城订单未完成'
        }
        if (!orderStatus) {
          str.reason = '未生成应付单'
        }
      }

      return str
    },
    onChangeTime (value) {
      // this.getTotalData()
      // this.initData()
    },
    handleSizeChange (val) {
      this.pagesize = val
      this.initData()
    },
    handleCurrentChange (val) {
      this.page = val
      this.initData()
    },
    getData () {
      this.getTotalData()
      this.initData()
    },
    getTotalData () {
      getReportCollectTotal({
        start_time: this.time[0] + ' 00:00:00',
        end_time: this.time[1] + ' 23:59:59'
      }).then(res => {
        this.totalData = res
      })
    },
    initData () {
      this.loading = true
      let params = {
        page: this.page,
        pagesize: this.pagesize,
        start_time: this.time[0] + ' 00:00:00',
        end_time: this.time[1] + ' 23:59:59'
      }

      getReportCollectDetail(params).then(res => {
        res.list.forEach(item => {
          item.list = []
          item.search = ''
          item.currentPage = 1
          item.totalCount = 0
        })
        this.tableData = res.list
        this.totalCount = res.total
        this.loading = false
      }).catch(err => {
        this.$message.error(err.msg)
      })
    },
    expandChange (row, expandedRows) {
      let index = this.tableData.findIndex(item => {
        return item.created_time === row.created_time
      })
      if (index !== -1) {
        if (row.created_time) {
          this.$set(this.tableData[index], 'loading', true)
          getReportCollectList({
            start_time: row.created_time + ' 00:00:00',
            end_time: row.created_time + ' 23:59:59',
            page: row.currentPage,
            pagesize: 10
          })
            .then(res => {
              let list = res.list
              row.totalCount = res.total
              if (list.length >= 0) {
                list.forEach(item => {
                  item.search = ''
                })
                row.list = list
                row.loading = false
                this.$set(this.tableData, 'index', row)
              } else {
                this.$set(this.tableData[index], 'loading', false)
              }
            })
        }
      }
      // return true
    },
    detailHandler (id) {
      getReportCollectInfo({
        id: id
      })
        .then(res => {
          this.centerDialogVisible = true
          this.dialogData = res
        })
    },
    searchDetailHandler (val, time) {
      console.log(val, time, 'searchDetailHandler')
      let index = this.tableData.findIndex(item => {
        return item.created_time === time
      })
      if (index !== -1) {
        let row = this.tableData[index]
        this.$set(this.tableData[index], 'loading', true)
        this.$set(this.tableData[index], 'currentPage', 1)
        getReportCollectList({
          start_time: row.created_time + ' 00:00:00',
          end_time: row.created_time + ' 23:59:59',
          type: val,
          page: row.currentPage,
          pagesize: 10
        })
          .then(res => {
            let list = res.list
            row.totalCount = res.total
            if (list.length >= 0) {
              console.log(this.tableData, 'this.tableData')
              row.list = list
              row.search = val
              row.loading = false
              this.$set(this.tableData, 'index', row)
            } else {
              this.$set(this.tableData[index], 'loading', false)
            }
          })
      }
    },
    handleCurrentChangeChild (val, scope) {
      // console.log(index, 'inxs')
      this.$set(this.tableData[scope.$index], 'currentPage', val)
      getReportCollectList({
        start_time: scope.row.created_time + ' 00:00:00',
        end_time: scope.row.created_time + ' 23:59:59',
        type: scope.row.search,
        page: scope.row.currentPage,
        pagesize: 10
      })
        .then(res => {
          let list = res.list
          scope.row.totalCount = res.total
          if (list.length >= 0) {
            console.log(this.tableData, 'this.tableData')
            scope.row.list = list
            scope.row.loading = false
            this.$set(this.tableData, 'index', scope.row)
          } else {
            this.$set(this.tableData[scope.$index], 'loading', false)
          }
        })
      this.searchDetailHandler()
    }

  },
  mounted () {
    this.getTotalData()
    this.initData()
  }
}
</script>

<style lang="scss" scoped>
  .select-wrap {
      display: flex;
      align-items: center;
      margin: 20px 0;
  }

  .select-wrap > div {
      padding-right: 20px;
  }

  .checkbox {
      margin-right: auto;
      margin-left: 15px;
  }
  .card-wrap{
    display: flex;
    margin-bottom: 20px;
    & > div{
      box-sizing: border-box;
      min-width:210px;
      height:135px;
      border-radius:9px;
      margin-right: 20px;
      padding:18px;
      color: #fff;
    }
    & > div:nth-child(1){
      background:linear-gradient(151deg,rgba(255,175,45,1) 0%,rgba(255,98,44,1) 100%);
      background:url('./../../assets/img/report/report4.png');
      box-shadow:0px 17px 12px -9px rgba(255,202,139,1);
      background-size:cover ;
    }
    & > div:nth-child(2){
      background:linear-gradient(151deg,rgba(255,214,65,1) 0%,rgba(255,174,40,1) 100%);
      background:url('./../../assets/img/report/report2.png');
      background-size:cover ;
      box-shadow:0px 17px 12px -9px rgba(255,214,108,1);
    }
    & > div:nth-child(3){
      background:linear-gradient(151deg,rgba(130,206,250,1) 0%,rgba(71,149,241,1) 100%);
      background:url('./../../assets/img/report/report1.png');
      background-size:cover ;
      box-shadow:0px 17px 12px -9px rgba(153,212,255,1);
    }
    & > div:nth-child(4){
      background:linear-gradient(151deg,rgba(128,173,255,1) 0%,rgba(129,99,255,1) 100%);
      background:url('./../../assets/img/report/report3.png');
      background-size:cover ;
      box-shadow:0px 17px 12px -9px rgba(178,173,255,1);
    }
    .card-title{
      font-size: 14px;
      margin-bottom: 5px;
    }
    .card-content{
      font-size: 28px;
      &-money{
        font-size: 15px;
      }
    }
    .card-footer{
      margin-top:20px;
      font-size: 14px;
      &-money{
        font-size: 18px;
      }
    }
    .card-img{

    }
  }
  .dialog-content{
    display: flex;
    // justify-content: space-around;
    text-align: left;
    > div{
      margin-left: 30px;
      min-width: 400px;
      padding:10px;
    }
  }
</style>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/pages/report/SummaryReport.vue